import React from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../../../incase-domain/components/modals/directory/Modal';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {IElementSequenceQuestion} from '../../../../../incase-domain/elements/question/questionSequence';
import {MAX_COMMENT_LENGTH} from '../../../../../incase-domain/validators/elements/constant';
import {swapArrayElement} from '../../../../../utils/utils';
import Button from '../../../../../incase-domain/components/button/Button';
import InputWithCharacterCounter from '../../common/InputWithCharacterCounter';

interface IChangeCommentProps {
    index: number;
    highlightedElement: IElementSequenceQuestion;
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaire | string, value: unknown) => void};
}

function SequenceChangeComment({index, highlightedElementChangeHandler, highlightedElement}: IChangeCommentProps): JSX.Element {
    const {t} = useTranslation();

    const [isOpenCommentModal, setIsOpenCommentModal] = React.useState<boolean>(false);
    const [comment, setComment] = React.useState<string>('');

    const answer = highlightedElement.sequence[index];

    function commentChangeHandler(index: number, value: string): void {
        const changedSequenceItem = {...highlightedElement.sequence[index]};
        changedSequenceItem.comment = value;
        const newSequence = swapArrayElement(highlightedElement.sequence, index, changedSequenceItem);
        highlightedElementChangeHandler.single('sequence', newSequence);
    }

    return (
        <>
            <Button
                leading={answer.comment.length ? 'solar:chat-square-bold' : 'solar:chat-square-linear'}
                variant="ghost"
                square
                size="sm"
                color={answer.comment.length ? 'secondary' : 'primary'}
                key={`${index}-comment`}
                onClick={() => {
                    setIsOpenCommentModal(true);
                    setComment(answer.comment);
                }}
            />
            <Modal
                isOpen={isOpenCommentModal}
                onCancel={() => {
                    setIsOpenCommentModal(false);
                    setComment('');
                }}
                onConfirm={() => {
                    commentChangeHandler(index, comment);
                    setIsOpenCommentModal(false);
                    setComment('');
                }}
                header={`${t('designSidepanel.answerComment')}`}
                description={`${t('designSidepanel.joinCommentToAnswer')} "${answer.text}"`}
                icon="solar:chat-line-bold"
                showConfirm
                showCancel
            >
                <InputWithCharacterCounter
                    className="c-sidepanel__input"
                    value={comment}
                    onChange={(value) => {
                        setComment(value);
                    }}
                    maxLength={MAX_COMMENT_LENGTH}
                    placeholder={t('designSidepanel.enterYourComment')}
                />
            </Modal>
        </>
    );
}

export default SequenceChangeComment;
